import { useTranslation } from '@shared/core';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { useCountdown } from '@shared/hooks/useCountdown';
import { useEventInfo } from '@shared/utils/eventInfo';
import { Box, Flex } from '@withjoy/joykit';
import React from 'react';
import { GuestSiteTypographyOverride } from '../GuestSiteTypographyOverride/GuestSiteTypographyOverride';
import { label2ToParagraphOverride, body4ToSubHeadingOverride } from '../GuestSiteTypographyOverride/GuestSiteTypographyOverride.constants';

const CountDown = (props: { dateMs: number }) => {
  const { countDown } = useCountdown(props.dateMs);
  const [showCountdown] = useIsFeatureEnabled('accommodationsPageCountdown');
  const { t } = useTranslation('guestSiteCustom');
  const translation = t('accommodations');
  return showCountdown ? (
    <Flex
      typographyVariant={'body2'}
      marginBottom={4}
      marginTop={8}
      flexDirection={'column'}
      alignItems={'center'}
      marginX="auto"
    >
      <GuestSiteTypographyOverride override={label2ToParagraphOverride}>
        <Box typographyVariant={'label1'}>{translation.countdownTitle()}</Box>
      </GuestSiteTypographyOverride>
      <GuestSiteTypographyOverride override={body4ToSubHeadingOverride}>
        <Box
          typographyVariant={'body4'}
          color="text.secondary"
          marginTop={3}
        >
          {translation.countdownDays({ days: countDown.days })}
        </Box>
      </GuestSiteTypographyOverride>
    </Flex>
  ) : null;
};

export const AccommodationsCountdownExperiment = () => {
  const { eventInfo } = useEventInfo();
  const countDownDateData =
    eventInfo?.settings.hideEventCountdown !== true && eventInfo?.finalizedDate?.milliseconds
      ? {
          dateMs: eventInfo.finalizedDate.milliseconds,
        }
      : undefined;
  const countDownDateInThePast = countDownDateData ? countDownDateData.dateMs < Date.now() : false;
  const countDownDate = countDownDateData && !countDownDateInThePast ? countDownDateData : undefined;
  return countDownDate ? <CountDown dateMs={countDownDate.dateMs} /> : null;
};
